import { CurrencyCode } from '../site-configs/types';

export enum NotificationType {
  DEPOSIT = 1,
  WITHDRAWAL = 2,
  CASHBACK = 20,
  STAKING = 40,
  CUSTOM = 1000,
}

export type Notification =
  | CustomNotification
  | WithdrawalNotification
  | DepositNotification
  | CashbackNotification
  | StakingNotification;

export type NotificationRequestParams = {
  pageNumber: number;
  size: number;
  startDate?: string;
  endDate?: string;
};

export type NotificationResponse = {
  notifications: Notification[];
};

export type NotificationCountResponse = {
  unreadCount: number;
};

type PayloadBase = {
  title: string;
  body: string;
};

type NotificationBase = {
  id: number;
  type: NotificationType;
  date: string;
  isRead: true;
  version: string;
  payload?: PayloadBase;
};


type WithPayload = { payload: PayloadBase };

export type WithAmountPayload = {
  payload: PayloadBase & {
    parameters: {
      sum: number;
      currency: CurrencyCode;
    };
  };
};

type CustomNotification = NotificationBase & WithPayload & {
  type: NotificationType.CUSTOM;
};


type WithdrawalNotification = NotificationBase & WithAmountPayload & {
  type: NotificationType.WITHDRAWAL;
};

type DepositNotification = NotificationBase & WithAmountPayload & {
  type: NotificationType.DEPOSIT;
};

type CashbackNotification = NotificationBase & WithAmountPayload & {
  type: NotificationType.CASHBACK;
};

type StakingNotificationPayload = PayloadBase & {
  parameters: {
    stakeId: number;
  };
};

type StakingNotification = NotificationBase & {
  type: NotificationType.STAKING;
  payload: StakingNotificationPayload;
};
